import { useEffect, useState } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  ${({ theme: { colors, monoFont } }) => `
  box-sizing: border-box;
  position: relative;
  max-width: 30rem;
  min-width: 20rem;
  height: 4rem;
  padding:0;
  line-height: 3.5rem;
  border-top: 2px solid ${colors('link')};
  border-bottom: 2px solid ${colors('link')};
  font-size: 1.3em;
  font-family: ${monoFont};
  background-color: ${colors('chrome', 0.5)};

  &::before,
  &::after {
    content: "";
    position: absolute;
    left: 40%;
    height: 0.8rem;
    width: 2px;
    margin-left: -1px;
    background-color: ${colors('link')};
  }

  &::before {
    top: 0;
  }

  &::after {
    bottom: 0;
  }

  .highlight {
    color: ${colors('link')};
    display: table-cell;
  }

  .leftSide {
    display: table-cell;
    width: 40%;
    text-align: right;
  }

  .rightSide {
    display: table-cell;
    width: 60%;
    text-align: left;
  }

  .timeoutBlock {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.1);
    transform-origin: 40%;
  }

  .timeoutBlockHidden {
    @extend .timeoutBlock;
    transform: scaleX(0);
    }
    `}
`

const isEmoji = (word) =>
  /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g.test(
    word
  )
const calcHighlightPoint = (word) =>
  isEmoji(word) ? -1 : Math.floor(word.replace(/[\W]/g, '').length / 2)
const textToWords = (text) => text?.split(/\s+/)
const ONE_MINUTE = 60 * 1000

const charTimeout = (words, wpm) => {
  const totalTime = Math.trunc((words?.length / wpm) * ONE_MINUTE)

  return totalTime / words?.join('')?.length
}

export const Spritz = ({ text, wordsPerMinute = 45 }) => {
  const [words, setWords] = useState(textToWords(text))
  const [word, setWord] = useState('')
  const [timer, setTimer] = useState(1000)
  const [index, setIndex] = useState(-1)
  const [highlight, setHighlight] = useState(2)

  useEffect(() => {
    setWords(textToWords(text))
  }, [text])

  useEffect(() => {
    setTimer(charTimeout(words, wordsPerMinute))
  }, [words])

  useEffect(() => {
    setWord(words?.[index] || word)
  }, [index])

  useEffect(() => {
    const doIncrement = () => {
      setIndex((i) => {
        const end = i < words?.length
        return end ? i + 1 : 0
      })
    }
    const intervalId = setInterval(doIncrement, timer)
    return () => clearInterval(intervalId)
  }, [timer])

  useEffect(() => {
    setHighlight(calcHighlightPoint(word))
  }, [word])

  if (!text || !word) return <div>loading</div>
  return (
    <Container>
      <div className="spritz">
        <div className="leftSide">
          {highlight !== -1 && word?.slice(0, highlight)}
        </div>
        <div className="highlight">
          {highlight === -1 ? word : word[highlight]}
        </div>
        <div className="rightSide">
          {highlight !== -1 && word?.slice(highlight + 1)}
        </div>
      </div>
    </Container>
  )
}
